<template>
  <div v-loading="contentLoading">
    <div class="title">
      基本信息
    </div>
    <table cellspacing="0" cellpadding="0" style="width: 100%" class="ReserveOrderTable">
      <tr>
        <td class="tableLabel">申请编号</td>
        <td class="tableContent">{{form.invoiceApplicationNo}}</td>
        <td class="tableLabel">申请状态</td>
        <td class="tableContent">
          <span v-if="form.status===0">草稿</span>
          <span v-if="form.status===1">已提交</span>
          <span v-if="form.status===2">已处理</span>
        </td>
        <td class="tableLabel">客户名称</td>
        <td class="tableContent">{{form.customerName}}</td>
      </tr>
      <tr>
        <td class="tableLabel">客户税号</td>
        <td class="tableContent">{{form.invoiceVATNO}}</td>
        <td class="tableLabel">银行账号</td>
        <td class="tableContent">{{form.invoiceAccounts}}</td>
        <td class="tableLabel">客户编号</td>
        <td class="tableContent">{{form.customerNo}}</td>
      </tr>
      <tr>
        <td class="tableLabel">申请日期</td>
        <td class="tableContent">{{form.createTime}}</td>
        <td class="tableLabel">提交日期</td>
        <td class="tableContent">{{form.submitTime}}</td>
        <td class="tableLabel">通过日期</td>
        <td class="tableContent">{{form.passTime}}</td>
      </tr>
      <td class="tableLabel">申请人</td>
      <td class="tableContent">{{form.creatorName}}</td>
      <td class="tableLabel"/>
      <td class="tableContent"/>
      <td class="tableLabel"/>
      <td class="tableContent"/>
    </table>
    <div
        style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
      关联发货单列表
    </div>
    <div style="color: #2d8cf0; font-size: 12px; margin-left: 1%; cursor: pointer" @click="changeDetailShow()">
      {{isShowDetail ? "隐藏" : "展开"}}
      <el-button style="padding: 1px 2px" :icon="isShowDetail ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"/>
    </div>
    <el-table
        v-if="isShowDetail"
        :data="form.detailList"
        :border="true"
        stripe
        @select="selectHandle"
        @select-all="selectHandle">
      <el-table-column type="index" align="center" label="#"/>
      <el-table-column prop="invoiceNo" align="center" label="发货单"/>
      <el-table-column prop="factoryNo" align="center" label="出厂编号"/>
      <el-table-column prop="sapSaleOrderNO" align="center" label="销售订单号"/>
<!--      <el-table-column prop="invoiceTotalAmount" align="center" label="价税合计"/>-->
      <el-table-column prop="invoiceType" align="center" label="开票类型"/>
    </el-table>
    <div>
      <div
          style="border-bottom: 1px solid #ddd; margin-bottom: 10px; padding-bottom: 5px; font-size: 16px; margin-top: 20px">
        订单附件
      </div>
      <div>
        <el-upload
            action=""
            multiple
            :http-request="submitUpload"
            :show-file-list="false"
            :disabled="uploadLoading"
            style="display: inline-block; float: left; margin: 5px;">
          <el-button type="primary" :disabled="!edit">
            <i class="el-icon-upload el-icon--right"/>
            附件上传
          </el-button>
        </el-upload>
      </div>
      <el-button
          type="primary"
          style="display: inline-block; float: left; margin: 5px;"
          :loading="downLoadLoading"
          @click="downloadAll">
        下载所有附件
      </el-button>
      <el-table ref="payData1" border :data="form.accessoryList">
        <el-table-column type="index" align="center" label="#" width="55"/>
        <el-table-column prop="fileName" align="left" label="附件描述" width="750"/>
        <el-table-column label="下载" width="70" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="download(scope.row)">下载</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="note" align="center" label="备注" show-overflow-tooltip/>
      </el-table>
    </div>
    <div style="text-align: right">
      <span v-if="edit" slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="submitLoading" @click="saveHandle">保存</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submit">提交</el-button>
      </span>
    </div>
  </div>
</template>

<script>


  import loginUtil from "@/util/loginUtil";

  export default {
    name: "InvoiceApplicationPreview",
    components: {},
    data() {
      return {
        downLoadLoading: false,
        selection: [],
        contentLoading: false,
        pkid: "",
        dialogVisible: false,
        submitLoading: false,
        uploadLoading: false,
        edit: 0,
        form: {},
        ruleValidate: {},
        isShowDetail: true,
        finalData: [],
        tempTableData: [],
        tableData: [],
      };
    },

    watch: {
      $route: {
        handler: function(val) {
          if (val.name === "InvoiceApplicationPreview") {
            this.getData(this.$route.query.billId, this.$route.query.selection);
          }
        },
      },
    },
    created() {
      this.getData(this.$route.query.billId, this.$route.query.selection);
    },

    methods: {

      //编辑查详情
      getData(id, selection) {
        console.log(id);
        if (id > 0) {
          this.$http.get("basic", "invoiceApplication/" + id).then((resp) => {
            this.form = resp;
          });
        } else {
          this.edit = 1;
          this.$http.post("basic", "invoiceApplication/getApplication", selection).then((resp) => {
            this.form = resp;
          });
        }
      },


      changeDetailShow() {
        this.isShowDetail = !this.isShowDetail;
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      downloadAll() {
        if (this.form.accessoryList.length === 0) {
          this.$message.error("没有可下载的附件！");
        }
        for (let item of this.form.accessoryList) {
          this.download(item);
        }
      },
      download(row) {
        let data = {
          name: row.fileName,
          uuid: row.filePath,
        };
        this.$http.exportFile("basic", "file/download", data).then(res => {
          console.log(res);
          let blob = new Blob([res.data], {type: "application"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },

      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/upload", formData)
          .then((res) => {
            this.uploadLoading = false;
            console.log(res);
            this.form.accessoryList.push({
              fileName: res.originalName,
              filePath: res.fullPath,
              note: "",
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },

      saveHandle() {
        this.$http.post("basic", "invoiceApplication", this.form)
          .then(() => {
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/invoicingManagement/invoiceApplication/InvoiceListApplicationList",
            });
          }).catch(() => {
            this.$message.error("保存失败");
            this.submitLoading = false;
          });
      },

      submit() {
        this.$http.post("basic", "invoiceApplication/saveAndSubmit", this.form)
          .then(() => {
            // 关闭标签
            this.$bus.$emit("closeTag", this.$route);
            this.$router.push({
              path: "/invoicingManagement/invoiceApplication/InvoiceListApplicationList",
            });
          }).catch(() => {
            this.$message.error("保存失败");
            this.submitLoading = false;
          });
      },
    },
  };
</script>
<style lang="scss" scoped>
.ReserveOrderTable {
  font-family: verdana, arial, sans-serif;
  font-size: 13px;
  color: #333333;
  border-left: 1px solid #dddddd;
  border-bottom: 1px solid #dddddd;
}

.ReserveOrderTable td {
  padding: 5px;
  border-right: 1px solid #dddddd;
  border-top: 1px solid #dddddd;
}

.title {
  font-size: 16px;
  border-bottom: 1px solid #ccc;
  width: 100%;
  margin: 10px 0 5px;
}

.tableLabel {
  width: 240px;
  text-align: left;
  background-color: #D1E6F5;
}

.tableContent {
  width: 340px;
  text-align: left;
  white-space: pre-wrap;
}

.detailTableLabel {
  width: 100px;
  text-align: left;
  background-color: #D1E6F5;
}



</style>